import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; excellence_modules: number; standard_categories: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; critical_bugs_clear: boolean; security_within_policy: boolean;
  performance_budgets_met: boolean; architecture_compliant: boolean;
  coverage_thresholds_met: boolean; static_analysis_passed: boolean; gaps?: string[];
};

export type Exl001Status = {
  sprint_id: string; objectives: number; excellence_modules: number; standard_categories: number;
  engineering_excellence: boolean; code_quality: boolean; architecture_compliance: boolean;
  reliability_engineering: boolean; release_engineering: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const engineeringExcellenceExl001Api = {
  dashboard: () => fetchG<SprintDashboard>('/exl001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/exl001/objectives').then((r) => r.objectives),
  excellenceModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/exl001/excellence-modules').then((r) => r.modules),
  standardCategories: () => fetchG<{ categories: { key: string; name: string; category: string }[] }>('/exl001/standard-categories').then((r) => r.categories),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/exl001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/exl001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/exl001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/exl001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Exl001Status>('/exl001/status'),
};
